var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { NagService } from 'app/services/nag.service';
import { MatDialogRef } from '@angular/material';
import { UserService } from 'app/services/user.service';
var NagPlacenameResoComponent = /** @class */ (function () {
    function NagPlacenameResoComponent(data, dialogRef, nagService, userService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.nagService = nagService;
        this.userService = userService;
        this.countyList = [];
    }
    NagPlacenameResoComponent.prototype.cancel = function () {
        this.dialogRef.close();
    };
    NagPlacenameResoComponent.prototype.apply = function () {
        var data = {
            existingRec: this.existingRec,
            county: this.parentCounty,
            standardName: this.standardName,
            placeTypes: this.placeTypes.filter(function (i) { return i.selected; }).map(function (i) { return i.name; })
        };
        this.dialogRef.close(data);
    };
    NagPlacenameResoComponent.prototype.onChangeCounty = function () {
        return __awaiter(this, void 0, void 0, function () {
            var standardRecords, existingPlaceTypes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nagService.getNagNamesStandardId(this.standardName, this.nctId, this.userService.customerInfo.givState, this.parentCounty.name)];
                    case 1:
                        standardRecords = _a.sent();
                        this.existingRec = standardRecords[0];
                        existingPlaceTypes = this.existingRec.placeTypes || [];
                        this.placeTypes.forEach(function (i) { return i.selected = existingPlaceTypes.indexOf(i.name) > -1; });
                        return [2 /*return*/];
                }
            });
        });
    };
    NagPlacenameResoComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var placeTypes, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.nagService.placeTypes;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nagService.getNagSubCategory()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        placeTypes = _a;
                        this.placeTypes = placeTypes.map(function (pt) {
                            return {
                                name: pt.name,
                                selected: false
                            };
                        });
                        this.countyList = this.data.countyList;
                        this.standardName = this.data.standard.name;
                        this.nctId = this.data.nctId;
                        return [2 /*return*/];
                }
            });
        });
    };
    return NagPlacenameResoComponent;
}());
export { NagPlacenameResoComponent };
